import TableComponent from "../../../../utilsComponent/TableComponent";
import { getPolicyMembers } from "../ClaimForm/helper";

const MemberDetails = ({policyData}) => {
  const membersData = getPolicyMembers(policyData)
  const memberColumns = [
  { header: "Member / Customer ID", accessor: "member_id" },
  { header: "Name", accessor: "name" },
  { header: "Relation with Proposer", accessor: "relation" },
  { header: "Date of Birth", accessor: "dob", type: "date" },
  { header: "Insured Days", accessor: "insuredDays", value: policyData?.insured_days},
  { header: "Sum Insured(₹)", accessor: "sumInsured", render: (data) => policyData?.insured_days * (Number(data?.sumInsured) || 0),
 } ,
];
  return (
    <div className="m-4">
      <TableComponent columns={memberColumns} data={membersData} title="Member Details" />
    </div>
  );
};

export default MemberDetails;